import '../scss/style.scss';

import * as $ from 'jquery';
import lozad from 'lozad';
import { openLink } from '../../../shared/js/open-link';
import { initTracker, updateOfferClickId, getSessionId, getVisitId } from '../../../shared/js/tracker';
import { buildApiUrl } from '../../../shared/js/api-host';

//Lazyload
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();

$(function () {
    initScripts();
});

function initScripts() {
    function getLink() {
        $("[data-offer-redirect]").click(function (event) {
            event.preventDefault();

            const $offer = $(this).parent();
            if ($offer.data('clickPending')) return;
            $offer.data('clickPending', true).css('pointer-events', 'none');

            const offerId = $offer.data("offer-id");
            const offerVisitId = $offer.data("offer-visit-id");
            const clickSendBase = buildApiUrl('/api/click/send') || `${window.location.origin}/api/click/send`;
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set('offerId', offerId);
            urlParams.set('sessionId', getSessionId() || '');
            urlParams.set('visitId', getVisitId() ?? '');
            urlParams.set('position', Array.from(document.querySelectorAll('[data-offer-id]')).indexOf($offer[0]) + 1);

            if (offerVisitId) {
              urlParams.set('offerVisitId', offerVisitId);
            }

            const apiUrl = `${clickSendBase}?${urlParams.toString()}`;

            $.ajax({
                url: apiUrl,
                method: "GET",
                timeout: 30000,
                success: function (response) {
                    if (response.status === "success" && response.link) {
                        const affSub4 = new URLSearchParams(window.location.search).get('aff_sub4');
                        let finalLink = response.link;

                        if (affSub4) {
                            try {
                                const url = new URL(finalLink, window.location.origin);
                                url.searchParams.set('aff_sub4', affSub4);
                                finalLink = url.toString();
                            } catch (_) {
                                // noop
                            }
                        }

                        updateOfferClickId(response.offerClickId || null, finalLink);
                        openLink(finalLink);
                    } else {
                        $offer.data('clickPending', false).css('pointer-events', '');
                        console.error("Error: invalid response");
                    }
                },
                error: function (error) {
                    $offer.data('clickPending', false).css('pointer-events', '');
                    console.error(error);
                },
            });
        });
    }

    function initRating() {
      document.querySelectorAll('.stars').forEach(star => {
        let rating = parseFloat(star.dataset.rating) || 0;
        rating = Math.max(0, Math.min(5, rating));
      
        const percent = (rating / 5) * 100;
        star.style.setProperty('--fill', percent + '%');
      });
    }

    getLink();
    initRating();
}
initTracker();
